export default class PensionContributionCalculator {
    constructor(employee, salary) {
        this.employee = employee;
        this.salary = salary;
    }

    calculate() {
        const percent = this.employee.pensionContribution;
        const grossSalary = this.salary.getBase('year');
        return (grossSalary / 100) * percent;
    }
}